(function($, FUNCTIONS, cssua){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const slideSpeed = '400';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		modal() {
			var scrollTopNow;

			var arr = ['1','2','3','4','5'];

			$.each(arr, function(i, val) {
				$('.idx-modal-btn' + val).on('click', function(event){
					$('.idx-modal-overlay' + val).addClass(a);
					scrollTopNow = $(window).scrollTop();
					$('body').addClass(f);
					$( '.container' ).css( {
						position: 'fixed',
						width: '100%',
						top: -1 * scrollTopNow,
						left: 0
					} );
					event.preventDefault();
				});

				$('.idx-modal-closeBtn' + val).on('click', function(event){
					$('.idx-modal-overlay' + val).removeClass(a);
					$('body').removeClass(f);
					$( '.container' ).css( {
						position: 'static',
					} );
					$(window).scrollTop(scrollTopNow);
					event.preventDefault();
				});

				$('.idx-modal-back' + val).on('click', function(event){
					$('.idx-modal-overlay' + val).removeClass(a);
					$('body').removeClass(f);
					$( '.container' ).css( {
						position: 'static',
					} );
					$(window).scrollTop(scrollTopNow);
					event.preventDefault();
				});
			});
		},
		setTicker() {
			$.ajax({
				url: 'https://www.shop-salon.jp/ajax/newsrelease/ladies.json',
				dataType: "jsonp",
				jsonp: 'news_list',
				success: function (data) {
					var ladiesHtml = '';
					for (var i = 0; i < data.news_list[0].cf_ng_news.length; i++) {
						var itemdate = new Date(data.news_list[0].cf_ng_news[i].cf_n_date);
						var itemyear = itemdate.getFullYear();
						var itemmonth = itemdate.getMonth() + 1;
						var itemday = itemdate.getDate();
						ladiesHtml += '<ul class="idx-mainVisual-news-content"><li class="idx-mainVisual-news-content-day">'+itemyear+'/'+itemmonth+'/'+itemday+'</li>';
						if(!data.news_list[0].cf_ng_news[i].cf_n_url) {
							ladiesHtml += '<li class="idx-mainVisual-news-content-lead"><a href="/newsrelease/detail/'+data.news_list[0].cf_ng_news[i]._key+'.html" class="mod-a" target="_new">'+data.news_list[0].cf_ng_news[i].cf_n_title+'</a></li></ul>';
						} else {
							ladiesHtml += '<li class="idx-mainVisual-news-content-lead"><a href="'+data.news_list[0].cf_ng_news[i].cf_n_url+'" class="mod-a" target="_new">'+data.news_list[0].cf_ng_news[i].cf_n_title+'</a></li></ul>';
						}
					}
					$('.js-ticker-ladies').prepend(ladiesHtml);
					const $setElm = $('.js-ticker');
					$setElm.slick({
						autoplay: true,
						slidesToShow: 1,
						slidesToScroll: 1,
						autoplaySpeed: 4000,
						loop: true,
						speed: 1000,
						arrows: false,
						dots: false
					});
					$setElm.addClass(a);
				},
				error:function(err){
					 console.log('ladies2', err);
				 },
			});
		},
		loadDelayScript(){
			var _this = this;
			_this.modal();
			_this.setTicker();
		}
	};

	$(() => FUNCTIONS.loadDelayScript());
})(window.jQuery, window.FUNCTIONS, window.cssua);